import React from 'react';
import { useLingui } from '@lingui/react/macro';
import { getJoinWaitListText, getSpeakToOnboardTeamText } from '../utils/themeUtils';

function SoldOutBox(props) {
    const {t} = useLingui();
    
    function getSoldOutText(waitlistActivated, currentWaitlistAvailability) {
        
        if(waitlistActivated && currentWaitlistAvailability > 0) {
            return getJoinWaitListText();
        }
        return getSpeakToOnboardTeamText();
    }

    return (
        <div className="w-full text-grey-darkest bg-grey-lighter p-2 md:p-4">
            <div className="uppercase text-2xl mb-2">
                {props.isBookingAllowed ? t({id: "sold_out_online"}) : t({id: "pre_registration_closed"})}
            </div>
            <div>
                {getSoldOutText(props.waitlistActivated, props.currentWaitlistAvailability)}
            </div>
        </div>
    );
}

export default SoldOutBox;